import * as types from './types';
import { loading } from 'State/actions';

const success = (type, payload) => {
  return { type, payload };
};

const errorResult = (type, payload) => {
  return { type, payload };
};

export const fetchData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_CLOSE_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        'Verification/GetReadyToCloseVerification'
      );

      dispatch(
        success(types.VERIFICATION_CLOSE_FETCH, {
          data: response.data.Data,
        })
      );
    } catch (error) {
      dispatch(errorResult(types.VERIFICATION_CLOSE_FETCH_ERROR, error));
    }

    dispatch(loading(types.VERIFICATION_CLOSE_FETCHING, false));
  };
};

export const saveCloseVerification = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_CLOSE_SUBMITTING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(
        'Verification/WriteCloseVerification'
      );

      dispatch(success(types.VERIFICATION_CLOSE_SUBMIT));
      dispatch(fetchData());
    } catch (error) {
      dispatch(errorResult(types.VERIFICATION_CLOSE_SUBMIT_ERROR, error));
    }

    dispatch(loading(types.VERIFICATION_CLOSE_SUBMITTING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/verificationclose/state/verificationclose/actions.js